import { render, staticRenderFns } from "./ProductsQuicktable.vue?vue&type=template&id=9032ae5a&"
import script from "./ProductsQuicktable.vue?vue&type=script&lang=js&"
export * from "./ProductsQuicktable.vue?vue&type=script&lang=js&"
import style0 from "./ProductsQuicktable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports